import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetPaymentAccountsRequestModel, GetPaymentAccountsResponseModel } from "@/features/accounts/payment/scraping/services/get-accounts-model";

export class GetPaymentAccountsApi {
  /**
   * MoneyLook 口座一覧取得API
   */
  public getPaymentAccounts = async (
    param: GetPaymentAccountsRequestModel
  ): Promise<GetPaymentAccountsResponseModel[]> => {
    const path = `/api/paymentaccounts/payments`;
    const res = await ApiClient.instance.get<GetPaymentAccountsResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
